<script>
    import { createEventDispatcher } from "svelte";
    import DTInputCell from "../common/DTInputCell.svelte";
    import Checkbox from "@smui/checkbox";
    import Tooltip, { Wrapper, Content } from "@smui/tooltip";
    import { mdiCheckboxOutline, mdiCheckboxBlankOutline } from "@mdi/js";
    import { _ } from "svelte-i18n";
    import { formatVolume, isNumber } from "../lib/Functions";

    export let value;
    export let valueConv;
    export let promoFlag;
    export let disabled = false;
    export let conversionRatio = 1;
    //export let participation = 1;
    export let price;
    export let currency = "EUR";
    export let priceEur;
    export let pricePromo;
    export let pricePromoEur;
    export let units;
    export let type = "day";
    export let day = null;

    let convertedValue = 0;
    let oldConversionRatio = 0;
    let oldParticipation = 0;

    const dispatch = createEventDispatcher();

    // Tooltip positioning
    let tooltipXpos = 0;
    let tooltipYpos = 0;

    function handleFocusOrHover(event) {
        const el = event.detail?.element || event.currentTarget;
        if (!el) return;

        const rect = el.getBoundingClientRect();
        tooltipXpos = rect.left;
        tooltipYpos = rect.top + rect.height;
    }

    function displayPrice(price, currency, priceEur) {
        return !priceEur || priceEur == price ? `${price} ${currency}` : `${price} ${currency} (${priceEur} EUR)`;
    }

    /*
    $:if ((conversionRatio != oldConversionRatio) || (participation != oldParticipation)) {
        convertedValue = Math.round(value * conversionRatio * Math.pow(10, roundFactor))/Math.pow(10, roundFactor);
        console.log("PsPurchasePopupPurchaseRowCell - value = "+value+", convertedValue = "+convertedValue+", conversionRatio = "+conversionRatio+", participation = "+participation);
        oldConversionRatio = conversionRatio;
        oldParticipation = participation;
    }

    function changeValue() {
        console.log("PsPurchasePopupPurchaseRowCell - START changeValue() - value = "+value+", convertedValue = "+convertedValue+", conversionRatio = "+conversionRatio);
        if (conversionRatio != 1) {
            convertedValue = Math.round(value * conversionRatio * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
        }
        console.log("PsPurchasePopupPurchaseRowCell - END changeValue() - value = "+value+", convertedValue = "+convertedValue+", conversionRatio = "+conversionRatio);
        dispatch("change");
    }

    function changeConvertedValue() {
        console.log("PsPurchasePopupPurchaseRowCell - START changeConvertedValue() - value = "+value+", convertedValue = "+convertedValue+", conversionRatio = "+conversionRatio);
        if (conversionRatio != 1) {
            value = Math.round((convertedValue / conversionRatio * Math.pow(10, roundFactor))) / Math.pow(10, roundFactor);
        }
        console.log("PsPurchasePopupPurchaseRowCell - END changeConvertedValue() - value = "+value+", convertedValue = "+convertedValue+", conversionRatio = "+conversionRatio);
        dispatch("change");
    }
*/
</script>

<Wrapper rich style="position: unset !important; --tooltip-top: {tooltipYpos}px; --tooltip-left: {tooltipXpos}px">
    <div class="datatable-cell {type == 'day' && promoFlag && !disabled ? 'yellow' : ''}">
        {#if type == "day"}
            <Checkbox
                on:focusin={handleFocusOrHover}
                on:mouseenter={handleFocusOrHover}
                bind:checked={promoFlag}
                disabled={disabled || !pricePromo}
                on:change={() => {
                    dispatch("promoFlagChange");
                }}
                aria-label="Promotion price checkbox"
            />

            <!-- Tooltip -->
            <Tooltip style="position: fixed !important; left: calc(var(--tooltip-left)) !important; top: var(--tooltip-top) !important;" surface$style="max-width: max-content">
                <Content style="max-width: fit-content;">
                    {#if !pricePromo}
                        <strong>{$_("no_promo_price")}:</strong>
                        {displayPrice(price, currency, priceEur)}
                        {$_("will_be_used")}
                    {:else if promoFlag}
                        <u>
                            <svg viewBox="0 0 24 24" class="tescoblue-text" style="width: 1.2rem; height: 1.2rem;">
                                <path fill="currentColor" d={mdiCheckboxOutline} />
                            </svg>
                            <strong> {$_("promo_price")}:</strong>
                            {displayPrice(pricePromo, currency, pricePromoEur)}
                            {$_("will_be_used")}
                        </u>
                        <br />
                        <svg viewBox="0 0 24 24" class="tescoblue-text" style="width: 1.2rem; height: 1.2rem;">
                            <path fill="currentColor" d={mdiCheckboxBlankOutline} />
                        </svg>
                        <strong> {$_("standard_price")}:</strong>
                        {displayPrice(price, currency, priceEur)}
                    {:else}
                        <svg viewBox="0 0 24 24" class="tescoblue-text" style="width: 1.2rem; height: 1.2rem;">
                            <path fill="currentColor" d={mdiCheckboxBlankOutline} />
                        </svg>
                        <strong> {$_("promo_price")}:</strong>
                        {displayPrice(pricePromo, currency, pricePromoEur)}
                        <br />
                        <u>
                            <svg viewBox="0 0 24 24" class="tescoblue-text" style="width: 1.2rem; height: 1.2rem;">
                                <path fill="currentColor" d={mdiCheckboxOutline} />
                            </svg>
                            <strong> {$_("standard_price")}:</strong>
                            {displayPrice(price, currency, priceEur)}
                            {$_("will_be_used")}
                        </u>
                    {/if}
                </Content>
            </Tooltip>
        {/if}

        {#if conversionRatio == 1}
            <DTInputCell
                input$data-qa="ps-popup-ps-row-cell-{day}"
                bind:value
                autofocus={false}
                editable={!disabled}
                class="small {disabled ? 'row-deleted' : ''}"
                on:change={() => {
                    dispatch("change", { day: day, type: type, value: value });
                }}
            />
        {:else}
            <DTInputCell
                input$data-qa="ps-popup-ps-row-cell-{day}"
                bind:value={valueConv}
                editable={!disabled}
                autofocus={false}
                class="small {disabled ? 'row-deleted' : ''}"
                on:change={() => {
                    dispatch("changeConverted", { day: day, type: type, valueConv: valueConv });
                }}
            />
        {/if}
    </div>

    {#if conversionRatio != 1}
        <div class="converted-value pr-2 {disabled ? 'row-deleted' : ''} {promoFlag && !disabled ? 'yellow' : ''}">
            {formatVolume(value)}&nbsp;{$_(units)}
        </div>
    {/if}
</Wrapper>

<style>
    .datatable-cell {
        display: flex;
        align-items: center;
    }
    .converted-value {
        font-size: 0.9em;
        color: gray;
        text-align: right;
        margin-left: auto;
    }
</style>
